export interface ProgressBarProps {
  /** Current value, clamped to 0..max. */
  readonly value: number;
  /** Value of a full bar. Default 100. */
  readonly max?: number | undefined;
  /** Accessible name (what is progressing), e.g. "Tiến độ Chương 2". */
  readonly label: string;
  /** Spoken value instead of the raw number, e.g. "12 trên 40 câu". */
  readonly valueText?: string | undefined;
  readonly className?: string | undefined;
}

/** Horizontal progress bar (`role="progressbar"`, 0..max). Styles: `.dcs-progress`. */
export function ProgressBar({ value, max = 100, label, valueText, className }: ProgressBarProps) {
  const top = max > 0 ? max : 100;
  const now = Number.isFinite(value) ? Math.min(Math.max(value, 0), top) : 0;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={top}
      aria-valuenow={now}
      aria-valuetext={valueText}
      className={className === undefined ? 'dcs-progress' : `dcs-progress ${className}`}
    >
      <div className="dcs-progress__bar" style={{ inlineSize: `${String((now / top) * 100)}%` }} />
    </div>
  );
}
